import en from './en-US'
import he from './he-HE'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...en,
  ...he
}
